/**
 * authLogger - centralized logging for auth/auth-config code paths.
 *
 * No logs in prod. Lower environments only (dev, int, uat); respects DEBUG for verbosity.
 */

function isProd() {
  try {
    const env = (window?._env_?.ENVIRONMENT || window?._env_?.environment || '').toString().toLowerCase();
    if (env === 'prod' || env === 'production') return true;
  } catch (_) {}
  try {
    if (process?.env?.NODE_ENV === 'production' && !window?._env_?.ENVIRONMENT) return true;
  } catch (_) {}
  return false;
}

function isDebugEnabled() {
  if (isProd()) return false;
  try {
    const envDebug = window?._env_?.DEBUG;
    if (typeof envDebug === 'boolean') return envDebug;
    if (typeof envDebug === 'string') return envDebug.toLowerCase() === 'true';
  } catch (_) {}
  try {
    return process?.env?.NODE_ENV !== 'production';
  } catch (_) {
    return false;
  }
}

export const authLogger = {
  debug: (...args) => {
    if (!isProd() && isDebugEnabled()) console.debug(...args);
  },
  info: (...args) => {
    if (!isProd() && isDebugEnabled()) console.info(...args);
  },
  warn: (...args) => {
    if (!isProd()) console.warn(...args);
  },
  error: (...args) => {
    if (!isProd()) console.error(...args);
  },
};



